import { Mapper } from '../../../../base/utils/mapper';
import { ReprocessStartResponseModel } from '../../../../domain/models/consult/reprocess-start-response.model';
import { ReprocessStartResponseEntity } from '../entities/reprocess-start-response.entity';
export class ReprocessDocumentStartImplementationRepositoryMapper extends Mapper<ReprocessStartResponseEntity, ReprocessStartResponseModel> {
    mapFrom(param: ReprocessStartResponseEntity): ReprocessStartResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ReprocessStartResponseModel): ReprocessStartResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}
